<template>
  <div class="app">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
    <header class="sticky-top">
      <nav class="navbar navbar-expand-md navbar-light bg-white shadow-sm py-3">
        <div class="container">
          <router-link :to="{ name: 'Landingpage' }" class="mx-auto nav-collection">
            <img class="nav-img" src="@/assets/images/logo.svg" alt="Logo">
            <span class="vertical-divider"></span>
            <span class="nav-txt">Uhren&Schmuck-Service</span>
          </router-link>
        </div>
      </nav>
    </header>

    <!-- Tag: /tags//shared/googleTagManager/gtm_002dnoscript.tag -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-W6C298Z" height="0" width="0"
        style="display:none;visibility:hidden"></iframe></noscript>

    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P8TV4X9" height="0" width="0"
        style="display:none;visibility:hidden"></iframe></noscript>

    <!-- /Tag: /tags//shared/googleTagManager/gtm_002dnoscript.tag -->

    <div v-if="Testsystem" id="alert">
      <b-alert show variant="warning" class="text-center">
        <i class="fas fa-exclamation-triangle"></i>
        Diese Version geht gegen die Test-Umgebung.
      </b-alert>
    </div>

    <template v-if="maintenanceMode">
      <Wartungsmodus />
    </template>

    <template v-else>
      <div
        v-if="this.$route.name !== 'Landingpage' && this.$route.name !== 'Success' && this.$route.name !== 'Error' && this.$route.name !== 'Help'"
        id="form-nav">
        <router-link :disabled="isDone(0) ? true : false" :class="isDone(0) ? 'done' : ''" :to="{ name: 'Diagnosis' }">
          <p>1</p>
          <span class="nav-step">Start</span>
        </router-link>

        <div :class="isSecondStep() ? 'done-separator' : 'separator'" />

        <router-link :is="hasNoServices() ? 'span' : 'router-link'" :class="isSecondStep() ? 'done' : ''"
          :to="{ name: 'Cart' }">
          <p>2</p>
          <span class="nav-step">Service-Leistung</span>
        </router-link>

        <div :class="isDone(1) ? 'done-separator' : 'separator'" />

        <router-link :is="uploadedImages() ? 'span' : 'router-link'" :class="{
          'done': isDone(2),
          'pointer': !uploadedImages()
        }" :to="{ name: 'PersonalData' }">
          <p>3</p>
          <span class="nav-step">Ihre Daten</span>
        </router-link>

        <div :class="isDone(2) ? 'done-separator' : 'separator'" />

        <router-link :disabled="isDone(3) ? true : false" :class="isDone(3) ? 'done' : ''" :to="{ name: 'Overview' }">
          <p>4</p>
          <span class="nav-step">Übersicht</span>
        </router-link>

      </div>

      <router-view />
    </template>

    <hr class="container my-4 footer-divider">

    <footer class="container footer">
      <div class="div-inner-margin small-letter footer-links">
        <a href="https://www.christ.de/content/legal/impressum" target="_blank" rel="noopener noreferrer">Impressum</a>
        <a href="https://www.christ.de/content/legal/datenschutz" target="_blank"
          rel="noopener noreferrer">Datenschutz</a>
        <a href="https://www.christ.de/content/legal/agb" target="_blank" rel="noopener noreferrer">AGB</a>
        <a href="https://www.christ.de/content/legal/widerruf" target="_blank" rel="noopener noreferrer">Widerruf</a>
      </div>
      <div class="small-letter div-margin-top footer-address">
        CHRIST Juweliere und Uhrmacher seit 1863 GmbH <br /> <span class="footer-mobile">-</span> Kabeler Straße 4, 58099
        Hagen
      </div>
      <div class="small-letter div-margin-top">
        Letzte Aktualisierung: {{ monthNow }} {{ yearNow }} (V.1.3.0)
      </div>
    </footer>

  </div>
</template>

<script>


import '../assets/js/gtm.js'
import Wartungsmodus from './Wartungsmodus'

export default {
  components: {
    Wartungsmodus
  },
  //https://stackoverflow.com/questions/36612847/how-can-i-bind-the-html-title-content-in-vuejs
  name: 'app',
  data() {
    return {
      isDisabled: false,
      monthNow: "",
      yearNow: ""
    }
  },
  created() {
    document.title = "Uhren&Schmuck-Service by CHRIST";
    let date = new Date();
    const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember"
    ];
    this.monthNow = monthNames[date.getMonth()];
    this.yearNow = date.getFullYear();
  },
  computed: {
    Testsystem: function () {
      if (process.env.VUE_APP_NODE_ENV === "production") {
        return false;
      } else if (process.env.VUE_APP_NODE_ENV === "development") {
        return true;
      } else throw new Error("Invalid VUE_APP_NODE_ENV");
    },
    maintenanceMode: function () {
      return process.env.VUE_APP_MAINTENANCE_MODE === "true";
    },
  },
  methods: {
    isDone: function (index) {
      return index - 1 < this.$store.state.currentStep
    },
    stepHandler: function (index) {
      if (index === this.$store.state.currentStep) {
        return index === this.$store.state.currentStep
      } else {
        return index - 1 < this.$store.state.currentStep
      }
    },
    isSecondStep: function () {
      if (this.$store.state.questions.length > 0) {
        if (this.$store.state.questions[0].diagnosis.answers) {
          return Object.keys(this.$store.state.questions[0].diagnosis.answers).length > 0;
        } else {
          return false;
        }
      }
      else {
        return false;
      }
    },
    hasNoServices: function () {
      if (this.$store.state.repairServices.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    uploadedImages: function () {
      if (this.$store.state.checkoutFormData.images.length > 0) {
        return false;
      } else {
        return true;
      }
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/sass/spa.scss";

* {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

#alert {
  width: 100% !important;
}

.app {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.div-margin-top {
  margin-top: 10px;
}

.div-inner-margin {
  a {
    margin-right: 10px;
  }
}

.small-letter {
  color: #666;
  font-size: .75rem;
}

.pointer {
  cursor: pointer !important;
}

@media only screen and (max-width: 768px) {

  html,
  body {
    width: 100%;
    overflow-x: hidden;
  }

  .name-footer {
    text-align: left !important;
  }
}
</style>
